import React from 'react';

import CreationButton from 'components/shadow_grid/shadows/creation/button';

export default function ShadowsHeader() {
  return (
    <div className="shadows-header">
      <h2 className="shadows-header-tab-title">Grids</h2>
      <CreationButton />
    </div>
  );
}
